import { getAuth } from 'firebase/auth';
import { doc, getDoc, getFirestore } from 'firebase/firestore';
import * as React from 'react';
import Logo from './components/Logo';

import Game from './components/Game/index';

const App = () => {
	const firestore = getFirestore();
	const user = getAuth().currentUser;
	const [categories, setCategories] = React.useState({
		Culture: { order: 1 },
		People: { order: 2 },
		Names: { order: 3 },
		Questions: { order: 4 },
		Animals: { order: 5 },
		Entertainment: { order: 6 },
		Food: { order: 7 },
	});
	const [answers, setAnswers] = React.useState(null);
	const [questionOfTheDay, setQuestionOfTheDay] = React.useState(null);
	const [highScore, setHighScore] = React.useState(0);
	const [PokiSDK, setPokiSDK] = React.useState(null);

	React.useEffect(() => {
		const tempPokiSDK =
			(typeof window !== 'undefined' && window.PokiSDK) || null;
		if (tempPokiSDK !== null) {
			setPokiSDK(tempPokiSDK);
			tempPokiSDK
				.init()
				.then(() => console.log('Poki SDK successfully initialized'))
				.catch(() =>
					console.log('Initialized, but the user likely has adblock')
				);
			tempPokiSDK.setDebug(false);
			tempPokiSDK.gameLoadingStart();
		}
		const loadQuestionsAsync = async () => {
			const Queries = await getDoc(doc(firestore, 'GameData/Queries'));
			if (Queries.exists) {
				const data = Queries.data();
				setQuestionOfTheDay(data.qotd);
				setAnswers(data.AllAnswers);
				setCategories(data.Categories);
				if (tempPokiSDK !== null) {
					tempPokiSDK.gameLoadingFinished();
				}
			}
		};
		loadQuestionsAsync();
	}, [firestore]);

	React.useEffect(() => {
		const loadHighScoreAsync = async () => {
			const HighScoreSnapshot = await getDoc(
				doc(firestore, `UserData/${user.uid}`)
			);
			if (HighScoreSnapshot.exists) {
				const data = HighScoreSnapshot.data();
				if (typeof data !== 'undefined') {
					setHighScore(data.highScore ? data.highScore.score : 0);
				}
			}
		};
		if (user !== null) {
			loadHighScoreAsync();
		}
	}, [user, firestore]);

	return (
		<>
			<main
				style={{
					display: 'flex',
					alignItems: 'center',
					flex: '1',
					transformOrigin: 'top center',
				}}>
				<div
					style={{
						flex: 1,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-evenly',
						minHeight: '600px',
						marginTop: 'var(--single)',
						maxWidth: '100%',
					}}>
					<div
						className="ElementWrapper"
						style={{
							textAlign: 'center',
							minHeight: '600px',
							maxWidth: '100%',
						}}>
						<Logo />
						<Game
							PokiSDK={PokiSDK}
							answers={answers}
							categories={categories}
							highScore={highScore}
							questionOfTheDay={questionOfTheDay}
							setHighScore={setHighScore}
						/>
					</div>
				</div>
			</main>
		</>
	);
};

export default App;
